/* @flow */

import getDadosFormulario from './get-formulario';
import xhr from '../../utils/xhr';
import mensagemSucesso from './mensagem-sucesso';
import exibirErro from '../../utils/exibir-erro';
import getElementoPorId from '../../utils/get-elemento-por-id';
import proximaEtapa from './proximaEtapa';

const cadastroCobranca = (empresasId: number) => {
    const form = getElementoPorId('formulario-cobranca');
    form.onsubmit = async (e) => {
        e.preventDefault();
        try {
            await xhr.post('/empresas/cobranca', ({
                ...getDadosFormulario(form),
                empresasId,
            }));
            mensagemSucesso('Dados para cobrança cadastrado.');
            proximaEtapa('aplicativo');
        } catch (err) {
            exibirErro(err);
        }
    };
};

export default cadastroCobranca;
